<template>
  <div class="list-searchable-options">
    <m-content
      :padding-x="7"
      :padding-top="7"
    >
      <m-input
        v-model:value="search"
        :placeholder="placeholder"
        full-width
        auto-focus
      />
    </m-content>
    <m-content :padding-y="4">
      <m-card-item
        v-for="(option, index) in filteredOptions"
        :key="index"
        :icon="option.icon"
        @click="emit('select', option)"
      >
        {{ option.text }}
      </m-card-item>
      <m-card-item
        v-if="filteredOptions.length === 0"
        disabled
      >
        {{ $t('general.noResults') }}
      </m-card-item>
    </m-content>
  </div>
</template>

<script setup>
import i18n from '@/lang';
import { computed, ref } from 'vue';

const props = defineProps({
  options: {
    type: Array,
    default: () => [],
  },
  placeholder: {
    type: String,
    default: i18n.t('general.typeToSearch'),
  },
});

const emit = defineEmits(['select']);

const search = ref('');

const filteredOptions = computed(() => props.options.filter((option) => option.text.toLowerCase().includes(search.value.toLowerCase())));
</script>

<style scoped lang="scss">
.list-searchable-options {
  min-width: 20rem;
  max-height: 80vh;
  overflow: hidden auto;
}
</style>
